import React, { Fragment, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { FaTimesCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";

import { useStateContext } from "../../../state/context";
import { setBilling, setCurrentPrescriptionInvoice, setCurrentPrescriptions } from "../../../state/actions/actions";
import { createPrescriptionsInvoice, dispenseDrug, getDrugPrices, getPaidPrescriptions, resetPaidPrescriptions } from "../../../state/actions/pharmacist.actions";


const PatientViewInvoiceModal = () => {
    const dispatch = useDispatch()
    const { modals, setModals } = useStateContext()
    const { accounts_pharmacyinvoice, set_patient_invoice_modal } = useSelector(state => state.root)
    return (
        <div className="fixed grid h-screen w-full z-10 bg-[#11111180] place-items-center"
            onClick={() => {
                // dispatch(setCurrentAccountsPharmacyInvoice({ data: null }))
                setModals({ ...modals, showPatientViewLabInvoiceModal: !modals.showPatientViewLabInvoiceModal })
            }}
        >
            <div className="bg-white w-[614px] rounded-t">
                <div className="h-[5px] bg-indigo-800 rounded-t"></div>
                <div className="flex justify-between space-y-5 px-[10px]">
                    <div className="flex flex-col items-center space-y-2">
                        <img
                            src="src/assets/images/logo.svg"
                            alt="logo"
                            className="w-[50px]"
                        />
                        <p className="text-[20px] text-gray-800 font-bold font-montserrat">Joyland Hospital</p>
                    </div>
                    <div>
                        <p className="text-[12px] text-gray-600 font-medium">
                            N<span className="underline underline-offset-1 text-[10px]">0</span> 33 Long River Lane, Rayfield
                        </p>
                        <p className="text-[12px] text-gray-600 font-medium">
                            info@joylandhospital.com
                        </p>
                        <p className="text-[12px] text-gray-600 font-medium">
                            joylandhospital.org
                        </p>
                    </div>
                </div>
                <div className="space-y-4 px-[10px] mt-5">
                    <div className="flex justify-start space-x-4">
                        <p className="flex flex-col text-[12px] font-medium text-gray-500">
                            <span className="text-gray-800">Subject:</span> {set_patient_invoice_modal?.department} Invoice
                            <span className="text-gray-800">Invoice number:</span> {set_patient_invoice_modal?.invoice_number}
                        </p>
                        <p className=" flex flex-col text-[12px] font-medium text-gray-500">
                            <div className="flex space-x-2"><span className="text-gray-800">Date Generated:</span> <p>{set_patient_invoice_modal?.date_generated}</p></div>
                            <div className="flex space-x-2"><span className="text-gray-800">Date Paid:</span> <p>{set_patient_invoice_modal?.date_paid}</p></div>
                           <div className="flex space-x-2"> <span className="text-gray-800">Paid By:</span> <p>{set_patient_invoice_modal?.payment_author?.first_name} {set_patient_invoice_modal?.payment_author?.last_name}</p></div>
                        </p>
                    </div>
                    <table className="rounded w-full cursor-default">
                        <thead className="">
                            <tr className='bg-yellow-100'>
                                <th
                                    scope="col"
                                    className="text-sm font-medium text-gray-900 pl-2 pr-[5em] py-2 text-left"
                                >
                                    Item
                                </th>
                                <th
                                    scope="col"
                                    className="text-sm font-medium text-gray-900 pr-[5em] py-2 text-left"
                                >
                                    Quantity
                                </th>
                                <th
                                    scope="col"
                                    className="text-sm font-medium text-gray-900 pr-[5em] py-2 text-left"
                                >
                                    Rate
                                </th>
                                <th
                                    scope="col"
                                    className="text-sm font-medium text-gray-900 pr-[5em] py-2 text-left"
                                >
                                    Amount
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="border-t border-b text-[12px] text-gray-900 font-light py-2 whitespace-nowrap">
                                    {set_patient_invoice_modal?.title}
                                </td>
                                <td className="border-t border-b text-[12px] text-gray-900 font-light py-2 whitespace-nowrap">
                                    1
                                </td>
                                <td className="border-t border-b text-[12px] text-gray-900 font-light py-2 whitespace-nowrap bg-yellow-200">
                                    {/* {accounts_pharmacyinvoice?.prescription_details.price} */}
                                </td>
                                <td className="border-t border-b text-[12px] text-gray-900 font-light py-2 whitespace-nowrap bg-yellow-200">
                                    {set_patient_invoice_modal?.amount}
                                </td>
                            </tr>
                            <tr>
                                <td className="border-t border-b text-[12px] text-gray-900 font-light py-2 whitespace-nowrap">
                                </td>
                                <td className="border-t border-b text-[12px] text-gray-900 font-light py-2 whitespace-nowrap">
                                </td>
                                <td className="border-t border-b text-[12px] text-gray-900 font-bold py-2 whitespace-nowrap bg-yellow-200">
                                    Tax: &#8358;
                                </td>
                                <td className="border-t border-b text-[12px] text-gray-900 font-medium underline underline-offset-1 py-2 whitespace-nowrap bg-yellow-200">
                                    {/* {accounts_pharmacyinvoice?.invoice_amount} */}0.00
                                </td>
                            </tr>
                            <tr>
                                <td className="border-t border-b text-[12px] text-gray-900 font-light py-2 whitespace-nowrap">
                                </td>
                                <td className="border-t border-b text-[12px] text-gray-900 font-light py-2 whitespace-nowrap">
                                </td>
                                <td className="border-t border-b text-[14px] text-white font-bold py-2 whitespace-nowrap bg-teal-900">
                                    Total:
                                </td>
                                <td className="border-t border-b text-[14px] text-white font-bold underline underline-offset-1 py-2 whitespace-nowrap bg-teal-900">
                                    {set_patient_invoice_modal?.amount}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="flex flex-col place-content-end w-1/2 italic text-[10px]">
                        <p className="underline font-bold">Terms And Conditions.</p>
                        <p>All payments finalized have no return policy.</p>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default PatientViewInvoiceModal